// ============================================================
// หน้า Letter — ตั้งค่าเอกสาร "จดหมายแจ้งเตือน"
// ------------------------------------------------------------
// ซ้าย = ตัวอย่างเอกสาร (ข้อมูลสมมติ) | ขวา = สวิตช์เปิด/ปิดแต่ละส่วน
// หัวข้อที่มีปุ่มดินสอ แก้ข้อความที่จะพิมพ์ลงเอกสารได้
//
// การโหลด/บันทึก/สวิตช์/popup แก้ข้อความ อยู่ที่คลาสแม่ DocumentSettingBase
// (ใช้ร่วมกับหน้าตั้งค่าเอกสารอีก 4 หน้า)
// ============================================================

import React from "react";

import "../../../shared/config/global.js";
import "../../../assets/css/bootstrap.css";
import Navbar from "../../../shared/layout/Navbar";
import LOGO from "../../../assets/images/logo.png";
import { getStorage, format_date, DocumentSettingBase } from "../../../shared/index.js";

// ค่าเริ่มต้นเมื่อโครงการยังไม่เคยตั้งค่า
// status = แสดงส่วนนี้ไหม | title = ข้อความที่พิมพ์ลงเอกสาร ("-" นำหน้าคือข้อความตายตัว แก้ไม่ได้)
const DEFAULT_SETTING = {
  header_1: { status: true, title: "-โลโก้" },
  header_2: { status: true, title: "" },
  header_3: { status: true, title: "" },
  header_4: { status: true, title: "-วันที่" },
  header_5: { status: true, title: "เรื่อง" },
  header_6: { status: true, title: "-เรียน" },
  header_7: { status: true, title: "" },
  th_1: { status: true, title: "-รายการ" },
  th_2: { status: true, title: "-เดือน" },
  th_3: { status: true, title: "-ราคา" },
  tr_1: { status: true, title: "-ค่าน้ำประปา" },
  tr_2: { status: true, title: "-ค่ารักษาอุปกรณ์น้ำ" },
  tr_3: { status: true, title: "-ค่าจัดเก็บขยะ" },
  tr_4: { status: true, title: "-ค่าใช้จ่ายส่วนกลาง" },
  tr_5: { status: true, title: "-อื่นๆ" },
  tr_6: { status: true, title: "-ค่าค้างชำระ" },
  tr_7: { status: true, title: "-ค่าเบี้ยปรับ" },
  tr_8: { status: true, title: "-รวมเป็นเงินทั้งสิ้น" },
  footer_1: { status: true, title: "" },
  footer_2: { status: true, title: "-ขอแสดงความนับถือ" },
  footer_3: { status: true, title: "" },
  footer_4: { status: true, title: "" },
  footer_5: { status: true, title: "" },
};

// แถวค่าใช้จ่ายในตารางตัวอย่าง — em = แถวที่ไม่แสดงเดือน (ค่าค้างชำระ/ค่าเบี้ยปรับ)
const TABLE_ROWS = [
  { k: "tr_1", n: "1. ค่าน้ำประปา" },
  { k: "tr_2", n: "2. ค่ารักษาอุปกรณ์การใช้น้ำ" },
  { k: "tr_3", n: "3. ค่าบริการจัดเก็บขยะ" },
  { k: "tr_4", n: "4. ค่าใช้จ่ายส่วนกลาง" },
  { k: "tr_5", n: "5. อื่นๆ" },
  { k: "tr_6", n: "6. ค่าค้างชำระ 0 งวด", em: true },
  { k: "tr_7", n: "7. ค่าเบี้ยปรับ", em: true },
];

// แผงตั้งค่าด้านขวา — [ป้ายชื่อ, key, แก้ข้อความได้ไหม]
const PANELS = [
  {
    title: "หัวเอกสาร",
    items: [
      ["โลโก้", "header_1"],
      ["โครงการ", "header_2", true],
      ["ที่อยู่", "header_3", true],
      ["วันที่", "header_4"],
      ["เรื่อง", "header_5"],
      ["เรียน", "header_6"],
      ["รายละเอียดส่วนหัว", "header_7", true],
    ],
  },
  {
    title: "หัวตาราง",
    items: [
      ["รายการ", "th_1"],
      ["เดือน", "th_2"],
      ["ราคา", "th_3"],
    ],
  },
  {
    title: "ข้อมูลในตาราง",
    items: [
      ["ค่าน้ำประปา", "tr_1"],
      ["ค่ารักษาอุปกรณ์น้ำ", "tr_2"],
      ["ค่าจัดเก็บขยะ", "tr_3"],
      ["ค่าใช้จ่ายส่วนกลาง", "tr_4"],
      ["อื่นๆ", "tr_5"],
      ["ค่าค้างชำระ", "tr_6"],
      ["ค่าเบี้ยปรับ", "tr_7"],
      ["รวมเป็นเงินทั้งสิ้น", "tr_8"],
    ],
  },
  {
    title: "footer",
    items: [
      ["รายละเอียดส่วนท้าย", "footer_1", true],
      ["ขอแสดงความนับถือ", "footer_2"],
      ["ชื่อผู้ออกใบแจ้ง", "footer_3", true],
      ["ตำแหน่ง", "footer_4", true],
      ["หมายเหตุ", "footer_5", true],
    ],
  },
];

export default class Letter extends DocumentSettingBase {
  documentKey = "letter";
  redirectTo = "/letter";

  state = { ...DocumentSettingBase.INITIAL_STATE, setting: DEFAULT_SETTING };

  render() {
    const s = this.state.setting;

    return (
      <div className="w-100 min-vh-100 fade-in">
        <Navbar page1="หน้าหลัก" page2="ตั้งค่า" page3="จดหมายแจ้งเตือน" />
        <div className="body">
          <div className="p-3">
            <h4>
              <b>จดหมายแจ้งเตือน</b>
            </h4>
            <div className="d-flex">
              {/* ---------- ตัวอย่างเอกสาร ---------- */}
              <div style={{ width: 816.38 }}>
                <div className="mx-auto bg-white p-5 pdf-large border-bottom" style={{ width: 1116, height: 1578, zoom: 0.75 }}>
                  <div className="p-4">
                    {/* หัวเอกสาร: โลโก้ + ชื่อโครงการ + ที่อยู่ + วันที่ */}
                    <div className="w-100 d-flex justify-content-between">
                      <div className="d-flex align-items-center">
                        <img src={getStorage("picture_paper") || LOGO} style={{ width: 100, height: 100, objectFit: "contain", marginRight: 6 }} alt="LOGO" className={`bg-contain mb-4${this.dNone("header_1")}`} />
                        <div>
                          <h2 className={`fw-bold px-2 mb-0${this.dNone("header_2")}`}>{s.header_2.title}</h2>
                          <div className={`px-2 mb-4${this.dNone("header_3")}`}>
                            {s.header_3.title.split("\n").map((e, i) => (
                              <div key={i}>{e}</div>
                            ))}
                          </div>
                        </div>
                      </div>
                      <div className={`wpx-250 text-right mb-4${this.dNone("header_4")}`}>วันที่ : {format_date(new Date(), "dd mmmm yyyy")}</div>
                    </div>

                    <div className={`mb-4${this.dNone("header_5")}`}>เรื่อง : แจ้งเตือนให้ชำระค่าใช้จ่ายตามข้อบังคับ</div>
                    <div className={`mb-4${this.dNone("header_6")}`}>เรียน : นายสมมติ นามสกุลสมมติ ห้องเลขที่ 123/45 อาคารเลขที่ 6 ต.หายยา อ.เมืองเชียงใหม่ จ.เชียงใหม่ 50100</div>
                    <div className={`mb-4${this.dNone("header_7")}`} style={{ textIndent: 80 }}>
                      {s.header_7.title}
                    </div>

                    {/* ตารางค่าใช้จ่าย */}
                    <table className="table table-borderless mb-4">
                      <tbody>
                        {TABLE_ROWS.map((row) => (
                          <tr key={row.k} className={this.dNone(row.k)}>
                            <td className={`w-100${this.dNone("th_1")}`}>{row.n}</td>
                            <td className={`w-100 text-nowrap pr-5${this.dNone("th_2")}`}>{!row.em ? `เดือน ${format_date(new Date(), "mmmm yyyy")}` : ""}</td>
                            <td className={`text-nowrap wpx-350${this.dNone("th_3")}`}>
                              <div className="d-flex justify-content-end p-0">
                                เป็นเงิน <div className="wpx-150 text-right pr-3">0.00</div> บาท
                              </div>
                            </td>
                          </tr>
                        ))}
                        <tr className={this.dNone("tr_8")}>
                          <td className={`w-100${this.dNone("th_1")}`} />
                          <td className={`w-100 text-nowrap pr-5${this.dNone("th_2")}`} />
                          <td className={`text-nowrap wpx-350${this.dNone("th_3")}`}>
                            <div className="d-flex justify-content-end p-0">
                              รวมเป็นเงินทั้งสิ้น <div className="wpx-150 text-right pr-3">0.00</div> บาท
                            </div>
                          </td>
                        </tr>
                      </tbody>
                    </table>

                    {/* ท้ายเอกสาร */}
                    <div className={`mb-4${this.dNone("footer_1")}`} style={{ textIndent: 80 }}>
                      {s.footer_1.title}
                    </div>
                    <div className="w-50 ml-auto text-center">
                      <div className={`text-center w-100 mt-5${this.dNone("footer_2")}`}>ขอแสดงความนับถือ</div>
                      <div className={`text-center w-100${this.dNone("footer_3")}`}>({s.footer_3.title})</div>
                      <div className={`text-center w-100 mb-5${this.dNone("footer_4")}`}>{s.footer_4.title}</div>
                    </div>
                    <div className={`mb-4${this.dNone("footer_5")}`}>
                      หมายเหตุ :{" "}
                      {s.footer_5.title.split("\n").map((e, i) => (
                        <div key={i}>{e}</div>
                      ))}
                    </div>
                  </div>
                </div>
              </div>

              {/* ---------- แผงตั้งค่า ---------- */}
              <div className="px-3">
                <div className="w-100 bg-white d-flex flex-wrap mb-auto">{PANELS.map(this.renderPanel)}</div>
                <div className="bg-white p-3">
                  <button className="btn btn-primary w-100" onClick={this.Update}>
                    บันทึก
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>

        {this.renderTextModal()}
      </div>
    );
  }
}
